export default __webpack_public_path__ + "static/media/power_supply_image.37ace1b1.svg";